module.exports = __webpack_public_path__ + "static/img/newsCard01.6f39169.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news_old/newsCard01.jpeg
// module id = eOxQ
// module chunks = 6